'use client'

import {
  API_URL,
  ONE_HOUR_IN_SECONDS,
  ONE_SECOND_IN_MILLISECONDS,
} from '@/constants'
import { fetchMenuArticles, fetchMenuItems, getMainNavCategories } from '@/v2/fetch/helpers/fetch-menu-items'
import { fetchNavbarSuppliers } from '@/v2/fetch/helpers/fetch-navbar-suppliers'
import useSWR, { SWRConfiguration } from 'swr'
import { NavigationIndex } from '../../../../v2/organisms/navigation/navigation-index/navigation-index'

const fetchOptions: SWRConfiguration = {
  revalidateOnFocus: false,
  revalidateOnReconnect: false,
  refreshInterval: ONE_HOUR_IN_SECONDS * ONE_SECOND_IN_MILLISECONDS,
}

export const NavigationClientWrapper = () => {
  const { data: uiPlacement } = useSWR(
    'menuItems',
    () => fetchMenuItems(),
    fetchOptions
  )

  const { data: articles } = useSWR(
    `${API_URL.ARTICLES.SEARCH}/${uiPlacement?.data}`,
    async () => {
      if (uiPlacement?.data) {
        const mainNavCategories = getMainNavCategories(uiPlacement.data)
        return await fetchMenuArticles(mainNavCategories)
      }
      return []
    },
    fetchOptions
  )

  const { data: navbarSuppliers } = useSWR(
    'navbarSuppliers',
    fetchNavbarSuppliers,
    fetchOptions
  )

  if (!uiPlacement) {
    return null
  }

  return (
    <NavigationIndex
      featuredArticles={articles}
      menuItems={uiPlacement?.data || {}}
      navbarSuppliers={navbarSuppliers?.suppliers}
      navbarVenues={navbarSuppliers?.venues}
    />
  )
}
